import { render, staticRenderFns } from "./RegionManager.vue?vue&type=template&id=1ebdfc3c&scoped=true"
import script from "./RegionManager.vue?vue&type=script&lang=js"
export * from "./RegionManager.vue?vue&type=script&lang=js"
import style0 from "./RegionManager.vue?vue&type=style&index=0&id=1ebdfc3c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebdfc3c",
  null
  
)

export default component.exports